import { RequisiteP2PTransactionResult } from '../types/TransactionResult'
import Money from '../types/Money'
import api from './api'

export const payP2P = async (
    paymentPageId: string,
    p2pData: object,
    extraFieldsData: Record<string, string>,
    money?: Money,
): Promise<RequisiteP2PTransactionResult> => {
    return await api('/api/payment-page/pay/p2p', {
        paymentPageId: paymentPageId,
        p2p: p2pData,
        ...money ? {
            money: {
                amount: parseFloat(money.amount) * 100,
                currency: money.currency,
            }
        } : {},
        extraFields: extraFieldsData,
    }) as RequisiteP2PTransactionResult
}
